import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

export const useLeaveQueue = () =>
  useMutation({
    mutationFn: async ({ id }: { id: string }) =>
      reactQueryPost(internalApi.helpWidget.leaveQueue({ id })),
  });
